import { Routes } from '@angular/router';
import {
  authGuard,
  billingGateChildGuard,
  companyAdminGuard,
  companyRouteChildGuard,
  companyRouteGuard,
} from './core';
import { MainLayoutComponent } from './layout';

export const routes: Routes = [
  {
    path: 'forms/:slug',
    loadComponent: () =>
      import('./features/workflows/components/workflow-form-public-render/workflow-form-public-render.component').then(
        (m) => m.WorkflowFormPublicRenderComponent
      ),
  },
  {
    path: 'accept-invite',
    pathMatch: 'full',
    redirectTo: 'auth/accept-invite',
  },
  {
    path: 'company-context',
    loadComponent: () =>
      import('./features/company-context/pages/company-context-error.page').then(
        (m) => m.CompanyContextErrorPageComponent
      ),
  },
  {
    path: 'c/:companyKey',
    component: MainLayoutComponent,
    canActivate: [authGuard, companyRouteGuard],
    canActivateChild: [companyRouteChildGuard, billingGateChildGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/home/home.routes').then((m) => m.homeRoutes),
      },
      {
        path: 'home',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'inbox',
        loadChildren: () => import('./features/inbox/inbox.routes').then((m) => m.inboxRoutes),
      },
      {
        path: 'assigned-comments',
        loadChildren: () =>
          import('./features/assigned-comments/assigned-comments.routes').then(
            (m) => m.assignedCommentsRoutes
          ),
      },
      {
        path: 'my-tasks',
        loadChildren: () =>
          import('./features/my-tasks/my-tasks.routes').then((m) => m.myTasksRoutes),
      },
      {
        path: 'projects',
        loadChildren: () =>
          import('./features/projects/projects.routes').then((m) => m.projectsRoutes),
      },
      {
        path: 'workflows',
        loadChildren: () =>
          import('./features/workflows/workflows.routes').then((m) => m.workflowsRoutes),
      },
      {
        path: 'empresa',
        canActivate: [companyAdminGuard],
        loadChildren: () =>
          import('./features/company-context/empresa.routes').then((m) => m.empresaRoutes),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.settingsRoutes),
      },
      {
        path: 'company-hub',
        canActivate: [companyAdminGuard],
        loadChildren: () =>
          import('./features/company-hub/company-hub.routes').then((m) => m.companyHubRoutes),
      },
      {
        path: 'cards/:cardId',
        loadChildren: () => import('./features/cards/cards.routes').then((m) => m.cardsRoutes),
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/users/users.routes').then((m) => m.usersRoutes),
      },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
  },
  { path: '', pathMatch: 'full', redirectTo: 'auth/login' },
  { path: '**', redirectTo: 'auth/login' },
];
